/* OVATIME · The Golden One PDP V14 */
(() => {
  "use strict";

  const PLAN_IMAGE_12 =
    "https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Produkt-3.png?v=1785250028";
  const PLAN_IMAGE_SINGLE =
    "https://cdn.shopify.com/s/files/1/0705/3623/3226/files/Produkt-1.png?v=1785250028";

  function setPlanImage(card, src, alt, quantity, eager = false) {
    if (!card) return false;
    const visual = card.querySelector(".tgo13-plan-product");
    const image = visual?.querySelector("img");
    if (!visual || !image) return false;

    image.src = src;
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.alt = alt;
    image.loading = eager ? "eager" : "lazy";
    image.decoding = "async";
    image.classList.add("tgo14-plan-image-ready");
    visual.classList.add("tgo14-plan-product--verified");

    if (quantity) {
      let badge = visual.querySelector(".tgo13-plan-product__qty");
      if (!badge) {
        badge = document.createElement("b");
        badge.className = "tgo13-plan-product__qty";
        visual.appendChild(badge);
      }
      badge.textContent = String(quantity);
    }

    return true;
  }

  function initialisePlanImages() {
    const hero = document.querySelector(".golden-smartrr.tgo13-hero");
    if (!hero) return false;

    const planImage12 = hero.dataset.planImage12 || PLAN_IMAGE_12;
    const planImage4 = hero.dataset.planImage4 || PLAN_IMAGE_SINGLE;
    const planImageOnetime = hero.dataset.planImageOnetime || PLAN_IMAGE_SINGLE;
    const twelveWeek = hero.querySelector(".golden-smartrr__benefits-box");
    const fourWeek = hero.querySelector(
      '.golden-smartrr__options .golden-smartrr__option[data-option="subscription"]',
    );
    const oneTime = hero.querySelector(
      '.golden-smartrr__option[data-option="onetime"]',
    );

    const ready12 = setPlanImage(
      twelveWeek,
      planImage12,
      "12-Wochen-Routine mit drei Dosen The Golden One",
      3,
      true,
    );
    const ready4 = setPlanImage(
      fourWeek,
      planImage4,
      "4-Wochen-Routine mit einer Dose The Golden One",
      1,
      true,
    );
    const readySingle = setPlanImage(
      oneTime,
      planImageOnetime,
      "Einmalkauf The Golden One",
      null,
    );

    if (ready12 && ready4 && readySingle) {
      hero.dataset.tgo14PlanImages = "ready";
      return true;
    }
    return false;
  }

  function initialise() {
    document.documentElement.classList.add("tgo14-ready");
    if (initialisePlanImages()) return;

    const observer = new MutationObserver(() => {
      if (initialisePlanImages()) observer.disconnect();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    window.setTimeout(() => observer.disconnect(), 8000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener("shopify:section:load", initialisePlanImages);
})();
